// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterV2-container {
  cursor: pointer;
}

.filterV2ButtonWrapper {
  border: none;
  background: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  position: relative;
}

.posCustomFilterV2LeftIconContainer {
  display: flex;
  align-items: center;
  gap: 4px;
}

.filterV2-list-wrapper {
  position: absolute;
  z-index: 100;
  background-color: var(--surface-white);
  margin-top: 10px;
  border: 1px solid #e9eaec;
  padding: 8px;
  border-radius: 6px;
  width: 500px;
}

.filterV2-list-header {
  font-size: 0.75rem;
  font-weight: 400;
  color: #414652;
  margin-bottom: 6px;
}

.filterV2-list-grid-container {
  border: 1px solid #e9eaec;
  border-radius: 6px;
}

.filterV2-list-title-left {
  border-right: 1px solid #e9eaec;
  border-bottom: 1px solid #e9eaec;
  padding: 8px;
}

.filterV2-list-title-right {
  padding: 8px;
  border-bottom: 1px solid #e9eaec;
}

/* ── Dark theme ── */
.dark .filterV2-list-wrapper {
  background-color: #1e293b;
  border-color: #334155;
}

.dark .filterV2-list-header {
  color: #94a3b8;
}

.dark .filterV2-list-grid-container {
  border-color: #334155;
}

.dark .filterV2-list-title-left {
  border-right-color: #334155;
  border-bottom-color: #334155;
  color: #f1f5f9;
}

.dark .filterV2-list-title-right {
  border-bottom-color: #334155;
  color: #f1f5f9;
}
`, "",{"version":3,"sources":["webpack://./client/src/customComponents/PosCustomerFilterV2/PosCustomerFilterV2.css"],"names":[],"mappings":"AAAA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sCAAsC;EACtC,gBAAgB;EAChB,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,gCAAgC;EAChC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,gCAAgC;AAClC;;AAEA,qBAAqB;AACrB;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB","sourcesContent":[".filterV2-container {\n  cursor: pointer;\n}\n\n.filterV2ButtonWrapper {\n  border: none;\n  background: none;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  position: relative;\n}\n\n.posCustomFilterV2LeftIconContainer {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.filterV2-list-wrapper {\n  position: absolute;\n  z-index: 100;\n  background-color: var(--surface-white);\n  margin-top: 10px;\n  border: 1px solid #e9eaec;\n  padding: 8px;\n  border-radius: 6px;\n  width: 500px;\n}\n\n.filterV2-list-header {\n  font-size: 0.75rem;\n  font-weight: 400;\n  color: #414652;\n  margin-bottom: 6px;\n}\n\n.filterV2-list-grid-container {\n  border: 1px solid #e9eaec;\n  border-radius: 6px;\n}\n\n.filterV2-list-title-left {\n  border-right: 1px solid #e9eaec;\n  border-bottom: 1px solid #e9eaec;\n  padding: 8px;\n}\n\n.filterV2-list-title-right {\n  padding: 8px;\n  border-bottom: 1px solid #e9eaec;\n}\n\n/* ── Dark theme ── */\n.dark .filterV2-list-wrapper {\n  background-color: #1e293b;\n  border-color: #334155;\n}\n\n.dark .filterV2-list-header {\n  color: #94a3b8;\n}\n\n.dark .filterV2-list-grid-container {\n  border-color: #334155;\n}\n\n.dark .filterV2-list-title-left {\n  border-right-color: #334155;\n  border-bottom-color: #334155;\n  color: #f1f5f9;\n}\n\n.dark .filterV2-list-title-right {\n  border-bottom-color: #334155;\n  color: #f1f5f9;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
